import { Timer } from 'three/addons/misc/Timer.js';
import * as THREE from 'three';
import * as CANNON from "cannon/build/cannon.js"
import { BaseGame } from './BaseGame.js';

export class PhysicsGame extends BaseGame {
    constructor(on_init = [], on_animate = [], ground_pos = -2) {
        super(on_init, on_animate);
        this.physics_world = null;
        this.init_physics(ground_pos)
    }

    init_physics(ground_pos){
        this.physics_world = new CANNON.World();
        this.physics_world.gravity.set(0,-3,0)
        this.create_ground(ground_pos)
        
    }

    create_ground(ground_pos){
        // ground plane
        this.physics_world.defaultContactMaterial = new CANNON.ContactMaterial(
            new CANNON.Material(),
            new CANNON.Material(),
            {
                friction: 0.8,
                restitution: 0.3,
                contactEquationStiffness: 1e6,
                contactEquationRelaxation: 3
            }
        );

        var groundShape = new CANNON.Plane();
        var groundBody = new CANNON.Body({ mass: 0});
        groundBody.addShape(groundShape);
        groundBody.quaternion.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), -Math.PI / 2);
        var wall_l = new CANNON.Body({ mass: 0});
        wall_l.addShape(new CANNON.Box(new CANNON.Vec3(1, 1, 1)));
        wall_l.position.set(-2, ground_pos, 0);
        this.physics_world.add(wall_l);

        var wall_r = new CANNON.Body({ mass: 0});
        wall_r.addShape(new CANNON.Box(new CANNON.Vec3(1, 1, 1)));
        wall_r.position.set(2, ground_pos, 0);
        this.physics_world.add(wall_r);
        


    
        groundBody.position.set(0,ground_pos,0)
        this.physics_world.add(groundBody);
    }

    animate(){
        requestAnimationFrame(this.animate);

        this.timer.update();
        if(!this.game_state || this.game_state.paused){
            return
        }

        var time_delta = this.timer.getDelta();
        this.on_animate.forEach(func => func(time_delta))

        this.updateScene(time_delta)
        this.update_text(time_delta)
        this.animate_physics(time_delta)

    }

    animate_physics(delta){
        let fixedTimeStep = 1/30
        let maxSubSteps = 1
        this.physics_world.step(fixedTimeStep, delta, maxSubSteps)
    }
    
}